export const environment = {
  SENTRY_RELEASE: 'v1.3-test',
  SENTRY_AUTH_TOKEN:
    'd9fdac6b9a5b49469b5883ab79d4216056da8ccd9806492f92b1fe2fd807f971',
  production: false,
  APP_LINK: 'http://localhost:4200/',
  STRIPE_KEY:
    'pk_test_51JRod3DYXkLuaaiolewBKjD3yXdn3BUZKwPHkcaE5x30OGC34nFYasfRdb0js9iwCwRZf55TkmzXx0MbC6fLwMTY00kBPlpuz6',
  DSN: 'https://fbe51f83a5394d37be6c3cc79c5b1984@o1001555.ingest.sentry.io/5963195',
  URL: 'http://localhost:8081/',
  ADD_TERM_AND_Condition: 'http://localhost:8081/terms',
  VALIDATE_TERM_AND_Condition:
    'http://localhost:8081/terms/patient/:patient_id/client/:client_id',
  TALKJS_APP_ID: 'tPer8yHb',
  MARKETING_SITE_URL: 'https://test-vytlsft.pantheonsite.io/',
};
